// extracted by mini-css-extract-plugin
export default {"advertWrapper":"dE23zuQ6","advert":"_5p7f4xRk","placeholder":"AdUnit_placeholder__Hsd1T4hm","background":"AdUnit_background__WpllsG2i","content":"AdUnit_content__eDjwobrW"};